import { t } from 'ttag'

import { Flex } from '@h2/components/layout/flex'
import { MuseoHeading, PillOutlineLink } from '@h2/features/planning/earlyStyles'

const CompletedLessons = () => {
  return (
    <>
      <MuseoHeading level="1">{t`You are caught up!`}</MuseoHeading>
      <Flex justifyContent="space-between" wrap="wrap" direction="column">
        <PillOutlineLink
          href="/planning/assignments"
          variant="outlined-cta"
          fontSize="20px"
          weight="bold"
          isHoverStyled={false}>
          {t`Review Your Work`}
        </PillOutlineLink>
      </Flex>
    </>
  )
}

export { CompletedLessons }
